/**
 * DELETE `admin/clients/:id/doctors/:doctorId` — удалить врача
 * (освобождает место по тарифу). Опасное действие → подтверждение в UI.
 */

import {apiEnabled, http} from '@services/utils';

import {buildClientDetail, patchDetailMock} from '../detailMocks';
import {MOCK_CLIENTS} from '../mocks';

export type RemoveDoctorInput = {clientId: string; doctorId: string};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const removeDoctor = async (input: RemoveDoctorInput): Promise<{ok: true}> => {
  if (!apiEnabled) {
    await sleep(300);
    const row = MOCK_CLIENTS.find((c) => c.id === input.clientId);
    if (row) {
      patchDetailMock(input.clientId, {
        staff: buildClientDetail(row).staff.filter((d) => d.id !== input.doctorId),
      });
      row.seatsUsed = Math.max(0, row.seatsUsed - 1);
    }
    return {ok: true};
  }

  await http(
    `admin/clients/${encodeURIComponent(input.clientId)}/doctors/${encodeURIComponent(input.doctorId)}`,
    {method: 'DELETE', skipCaseConversion: true},
  );
  return {ok: true};
};
